// Per-coin CSV "data dump" — downloads the server's captured swaps for one
// mint (or fut:<COIN>) from /export/swaps.csv on the :8766 HTTP proxy.
//
// Auth is a shared secret: VITE_EXPORT_TOKEN here must match EXPORT_TOKEN on
// the server. NOTE: Vite inlines VITE_* into the public bundle, so this is a
// gate against drive-by scraping, not a real per-user secret.
import { HTTP_PROXY_BASE } from './chartUtils'

const EXPORT_TOKEN = import.meta.env.VITE_EXPORT_TOKEN || ''

/** Fetch the CSV and hand it to the browser as a file download.
 *  Resolves { name, bytes } on success; throws Error(message) on failure. */
export async function downloadSwapsCsv(mint, { from, to } = {}) {
  if (!mint) throw new Error('No coin loaded')
  if (!EXPORT_TOKEN) throw new Error('CSV export not configured (VITE_EXPORT_TOKEN)')
  const qs = new URLSearchParams({ mint })
  if (from) qs.set('from', String(from))
  if (to) qs.set('to', String(to))
  let res
  try {
    res = await fetch(`${HTTP_PROXY_BASE}/export/swaps.csv?${qs}`, {
      headers: { 'X-Export-Token': EXPORT_TOKEN },
      cache: 'no-store',
    })
  } catch {
    throw new Error('CSV export: server unreachable')
  }
  if (!res.ok) {
    let msg = `HTTP ${res.status}`
    try { const j = await res.json(); if (j?.error) msg = j.error } catch { /* not JSON */ }
    throw new Error(`CSV export failed: ${msg}`)
  }
  const blob = await res.blob()
  const cd = res.headers.get('Content-Disposition') || ''
  const m = /filename="?([^";]+)"?/i.exec(cd)
  const name = m ? m[1] : `${String(mint).replace(':', '-').slice(0, 8)}_swaps.csv`
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Revoke later: Safari (incl. iOS) can still be reading the blob on click.
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
  return { name, bytes: blob.size }
}
